import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useSelectAccount = () => {
    const [, setSearchParams] = useSearchParams();
    return useCallback(
        (accountId: number | 'personal') => {
            setSearchParams((params) => {
                if (accountId === 'personal') {
                    params.delete('accountId');
                    return params;
                }
                params.set('accountId', String(accountId));
                return params;
            });
        },
        [setSearchParams],
    );
};
